export default __webpack_public_path__ + "static/media/signup-illustration.0c3d8e16.svg";